export function money(cents: number | undefined, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((cents ?? 0) / 100);
}

export function shortDate(iso: string | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function relTime(iso: string | undefined): string {
  if (!iso) return '';
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
}

const LABELS: Record<string, string> = {
  needs_scheduling: 'Needs scheduling', in_progress: 'In progress', en_route: 'En route',
  partially_paid: 'Partially paid', past_due: 'Past due', read_only: 'Read only',
};
/** Turn a snake_case enum code into a human label. */
export function label(code: string | undefined): string {
  if (!code) return '';
  if (LABELS[code]) return LABELS[code]!;
  return code.charAt(0).toUpperCase() + code.slice(1).replace(/_/g, ' ');
}

/** Map a status code to a semantic tone used by <Badge>. */
export function statusTone(code: string): 'neutral' | 'info' | 'success' | 'warning' | 'danger' {
  switch (code) {
    case 'completed': case 'paid': case 'approved': case 'won': case 'active': return 'success';
    case 'past_due': case 'canceled': case 'declined': case 'void': case 'lost': case 'failed': return 'danger';
    case 'needs_scheduling': case 'draft': case 'new': case 'partially_paid': return 'warning';
    case 'in_progress': case 'en_route': case 'dispatched': case 'arrived': case 'scheduled':
    case 'sent': case 'viewed': return 'info';
    default: return 'neutral';
  }
}
